import React from "react"
import { useTheme, Box, Center } from "@chakra-ui/react"
import { MdDirectionsBike } from "react-icons/md"
import { Marker } from "react-map-gl"
import Mapbox from "../mapbox/Mapbox"
import { Bbox, Coord, createBbox } from "../lib/helpers/map"
import { BikeEntity } from "../lib/types/bike"
import { BIKE_MARKER_COLORS } from "../lib/static/bike"

interface LiveChaseMapboxProps {
  bike: BikeEntity | undefined
}

const LiveChaseMapbox: React.FC<LiveChaseMapboxProps> = ({ bike }) => {
  const theme = useTheme()
  const [bbox, setBbox] = React.useState<Bbox | undefined>()

  React.useEffect(() => {
    if (bike?.longitude && bike?.latitude) {
      const coords: Coord[] = [[bike.longitude, bike.latitude]]
      setBbox(createBbox(coords))
    }
  }, [bike])

  return (
    <>
      {bbox && (
        <Mapbox
          fitBounds={bbox}
          fitBoundsOptions={{ duration: 30, linear: true }}
          style={{ height: `50vh`, width: `100%` }}
          dragPan={false}
        >
          {bike && (
            <Marker
              anchor="center"
              longitude={bike.longitude!}
              latitude={bike.latitude!}
              key={bike.uuid}
              data-state={bike.state}
            >
              <Center
                boxSize="40px"
                zIndex={1}
                borderRadius="50%"
                overflow="hidden"
                bg={theme.colors[BIKE_MARKER_COLORS[bike.state]]["400"] || "blue.400"}
              >
                <Box boxSize="22px" color="white" as={MdDirectionsBike} />
              </Center>
            </Marker>
          )}
        </Mapbox>
      )}
    </>
  )
}

export default LiveChaseMapbox
